import API from "@core/api/api";

/**
 * Create a new user (Admin/Manager only)
 * @param {Object} userData - User data including role, email, password, etc.
 * @returns {Promise} API response
 */
export const createUser = async (userData) => {
  const response = await API.post("/users/admin/create", userData);
  return response.data;
};

export const fetchAllUsers = async (params) => {
  const response = await API.get(`/users?${params}`);
  return response.data;
};

export const updateActiveStatus = async (params) => {
  console.log("updateActiveStatus params:", params);
  try {
    const response = await API.put(`/users/${params.id}/status`, params.values);
    console.log("updateActiveStatus response:", response.data);
    return response.data;
  } catch (error) {
    console.error("updateActiveStatus error:", error);
    throw error;
  }
};

export const updateUser = async (params) => {
  const response = await API.patch(`/users/${params.id}`, params.values);
  return response.data;
};

export const updateUserBank = async (params) => {
  const response = await API.post(`/users/banking`, params.values);
  return response.data;
};

export const updateUserBankByAdmin = async (params) => {
  const response = await API.post(`/users/${params.id}/banking`, params.values);
  return response.data;
};

export const userUpdateProfileImage = async (params) => {
  const response = await API.patch(
    `/users/${params.id}/profileimage`,
    params.values
  );
  return response.data;
};

// Additional user-specific functions
export const getUserProfile = async (id) => {
  const response = await API.get(`/users/${id}`);
  return response.data;
};

export const fetchUserById = async (id) => {
  const response = await API.get(`/users/${id}`);
  return response.data;
};

export const changeUserPassword = async (params) => {
  const response = await API.put(`/users/${params.id}/change-password`, {
    password: params.password,
  });
  return response.data;
};

export const updateUserRole = async (params) => {
  const response = await API.put(`/users/${params.id}/role`, {
    role: params.role,
  });
  return response.data;
};

// Banking validation functions
export const approveBankingInfo = async (params) => {
  const response = await API.put(`/users/banking/${params.id}/approve`, {
    notes: params.notes,
  });
  return response.data;
};

export const rejectBankingInfo = async (params) => {
  const response = await API.put(`/users/banking/${params.id}/reject`, {
    reason: params.reason,
    notes: params.notes,
  });
  return response.data;
};

export const getPendingBankingRequests = async (params = "") => {
  const response = await API.get(`/users/banking/pending?${params}`);
  return response.data;
};
